import { useCallback, useContext, useEffect, useRef } from 'react';

import { RovoThinkingMorphContext } from './RovoThinkingMorphContext';

/** Hold completion until the pill has finished expanding, including its detail reveal. */
export function useRovoThinkingMorphCompletion({
	isReady,
	isError,
	onComplete,
}: {
	isReady: boolean;
	isError: boolean;
	onComplete: () => void;
}): () => void {
	const { isExpanding = false } = useContext(RovoThinkingMorphContext);
	const pending = useRef(false);
	useEffect(() => {
		if (!isReady) {
			pending.current = false;
		} else if (!isExpanding && !isError && pending.current) {
			pending.current = false;
			onComplete();
		}
	}, [isReady, isError, isExpanding, onComplete]);
	return useCallback(() => {
		if (isExpanding) {
			pending.current = true;
		} else {
			onComplete();
		}
	}, [isExpanding, onComplete]);
}
